import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';
import { useMst } from '../../../models/rootModel';
import { SuggestOffer } from './SuggestPlan.styled';
import { ErrorType, recordError } from '../../../models/apiWrappers/api/exceptions';
import { useAnalytics } from '../../../utils/analytics';
import { growthBook } from '../../../providers/featureFlag/growthbook';
import { FeatureFlag } from '@7chairs/types';
import { Variant } from '../../steps/PickAProduct/PickAProduct.types';

interface SuggestPlanProps {
  interval: 'year';
}

const PlanNameObj = {
  year: 'annual',
};

export const SuggestPlan: FC<SuggestPlanProps> = observer(({ interval }) => {
  const { UserPayment } = useMst();
  const plan = UserPayment.getChoosenPlan();
  const variantToBeUsed: Variant = growthBook?.getFeatureValue(FeatureFlag.useWebPricingTestWeekly, false)
    ? Variant.v3
    : Variant.v2;

  const analytics = useAnalytics();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const originalPlan = useMemo(() => plan, []);

  const planKeyByInterval = useMemo(
    () =>
      Object.keys(UserPayment.stripePlans).find(
        (key) =>
          UserPayment.stripePlans[key].interval === interval &&
          UserPayment.stripePlans[key].metadata.useOnlyInVariant === variantToBeUsed
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onPressOffer = () => {
    // if we are in the original plan user will click and see annual offer
    if (originalPlan?.id === plan?.id) {
      analytics.track('click see annual plan');
      if (planKeyByInterval) UserPayment.setChosenPlanPosition(planKeyByInterval);
      else {
        recordError(ErrorType.HANDLED, 'onPressOffer - plan wasn`t found', { originalPlan, plan, interval });
      }
    } else {
      analytics.track('click get back to original plan');
      const originalPlanInd = Object.keys(UserPayment.stripePlans).find(
        (ind) => UserPayment.stripePlans[ind].id === originalPlan?.id
      );
      if (originalPlanInd) UserPayment.setChosenPlanPosition(originalPlanInd);
      else {
        recordError(ErrorType.HANDLED, 'onPressOffer - plan wasn`t found', { originalPlan, plan, interval });
      }
    }
  };

  const percentOff =
    plan &&
    planKeyByInterval &&
    (
      (1 - +UserPayment.stripePlans[planKeyByInterval]?.metadata?.monthlyPrice / +plan?.metadata.monthlyPrice) *
      100
    ).toFixed(0);

  if (!percentOff) return null;

  return (
    <SuggestOffer showPlan={plan?.interval === interval} onClick={onPressOffer}>
      {plan === originalPlan
        ? `Save 
      ${percentOff}% by switching to an ${PlanNameObj[interval]} plan`
        : `Back to previous plan`}
    </SuggestOffer>
  );
});
